import styled, { css } from 'styled-components';
import { FuelCallout, FuelDivider } from '@frete.com/fuel-react';

export const Container = styled.div`
  ${({ theme: { spacing } }) => css`
    position: relative;
    display: grid;
    grid-gap: ${spacing.km6};
    width: 100%;
    grid-template-columns: 100%;
    grid-auto-rows: min-content;
  `}
`;

export const Callout = styled(FuelCallout)`
  ${({ theme: { spacing } }) => css`
    margin-bottom: ${spacing.km2};
    height: fit-content;
  `}
`;

export const ErrorContent = styled.div`
  ${({ theme: { spacing } }) => css`
    display: grid;
    gap: calc(${spacing.km3} + ${spacing.km4});
    overflow-y: auto;
    max-height: calc(100vh - 22.5rem);

    &::-webkit-scrollbar {
      display: none;
    }
  `}
`;

export const ErrorDisclaimerContent = styled.div`
  ${({ theme: { spacing } }) => css`
    display: grid;
    gap: ${spacing.km5};
  `}
`;

export const ErrorDisclaimer = styled.em`
  font-weight: inherit;
  color: inherit;
`;

export const SessionDivider = styled(FuelDivider)`
  ${({ theme: { spacing } }) => css`
    margin: 0 -${spacing.km6};
  `}
`;

export const WhatsappContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;
